import React from 'react';
interface TapeBadgeProps {
  text: string;
  color?: 'bone' | 'cyan' | 'blaze';
  rotation?: number;
  className?: string;
}
export function TapeBadge({
  text,
  color = 'bone',
  rotation = -2,
  className = ''
}: TapeBadgeProps) {
  const bgColors = {
    bone: 'bg-otter-bone text-otter-black',
    cyan: 'bg-otter-cyan text-otter-black',
    blaze: 'bg-otter-blaze text-otter-bone'
  };
  return <div className={`inline-block px-4 py-1 font-display text-xl uppercase tracking-wider shadow-sm ${bgColors[color]} ${className}`} style={{
    transform: `rotate(${rotation}deg)`,
    clipPath: 'polygon(2% 0, 98% 2%, 100% 98%, 0 100%)'
  }} data-id="element-299">
      {text}
    </div>;
}